import React, { FC } from 'react';

import { Container, Box, Typography } from '@mui/material';
import cx from 'classnames';

import SafeLink from '../../blocks/Header/components/SafeLink/SafeLink';
import { CtaBlock as CtaBlockType } from '../../types';
import { useTextStyles } from '../../utils/styles';
import { CustomButton } from '../UI/CustomButton';
import useStyles from './styles';

interface CtaBlockProps {
  data: CtaBlockType;
}

const CtaBlock: FC<CtaBlockProps> = ({ data }) => {
  const background = data?.background;
  const isExtendedCta = Boolean(data?.title_text || data?.sub_title);

  const classes = useStyles(background, isExtendedCta)();
  const textClasses = useTextStyles();

  return data?.link && data?.title ? (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'cta-block',
        !isExtendedCta && 'cta-btn-block',
      )}
    >
      <Container className={cx(classes.container, 'cta-block__container')}>
        {isExtendedCta && (
          <div className={classes.textBlock}>
            {data?.title_text && (
              <Typography variant="h2" className={cx(textClasses.h2, classes.title)}>
                {data?.title_text}
              </Typography>
            )}
            {data?.sub_title && (
              <Typography className={cx(textClasses.bodyText, classes.description)}>
                {data?.sub_title}
              </Typography>
            )}
          </div>
        )}
        <SafeLink to={data?.link || '#'} className={cx(classes.ctaLink, 'cta-block__link')}>
          <CustomButton btnClass={cx(classes.btn, 'cta-block__button')}>{data?.title}</CustomButton>
        </SafeLink>
      </Container>
    </Box>
  ) : null;
};

export default CtaBlock;
